module.exports = __webpack_public_path__ + "img/description.4ab075af.png";